var React = require('react');

function IconMobileDesign (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.70941 19.9899C7.21771 19.9899 6 18.6481 6 17.0036V5.98635C6 4.34184 7.21771 3 8.70941 3H14.2906C15.7823 3 17 4.34184 17 5.98635V17.0136C17 18.6582 15.7823 20 14.2906 20H8.70941V19.9899ZM8.70941 4.67478C8.04982 4.67478 7.51199 5.25994 7.51199 5.97626V17.0036C7.51199 17.7199 8.04982 18.305 8.70941 18.305H14.2906C14.9502 18.305 15.488 17.7199 15.488 17.0036V5.98635C15.488 5.27003 14.9502 4.68487 14.2906 4.68487H13.6513V4.75549C13.6208 5.02789 13.4179 5.22967 13.1744 5.22967H9.82565C9.5821 5.22967 9.3893 5.02789 9.35886 4.75549V4.68487H8.70941V4.67478Z","fill":"#030303"}));
}

IconMobileDesign.defaultProps = {"width":"32","height":"32","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconMobileDesign;

IconMobileDesign.default = IconMobileDesign;
